window.addReservation = function(url) {
  if (window._addReservationXhr) {
    window._addReservationXhr.abort();
  }

  Sidepanel.close();
  OpenLargeSidepannel({ showLoader: true })

  window._addReservationXhr = $.ajax({
    type: 'GET',
    url: url,
    converters: {
      'text script': function(text) {
        try {
          jQuery.globalEval(text);
        } catch (e) {
          console.error('[addReservation] Error evaluating response:', e);
          document.querySelector('#j-sidepanel').setAttribute('data-show-loader', false);
        }
        return text;
      }
    }
  }).fail(function(_jqXHR, textStatus) {
    if (textStatus !== 'abort') {
      document.querySelector('#j-sidepanel').setAttribute('data-show-loader', false);
    }
  }).always(function() {
    window._addReservationXhr = null;
  });
}

$(document).on('click', '[data-add-reservation-url]', function() {
  window.addReservation($(this).data('add-reservation-url'));
});
